import { LogoMark } from "./icons";
import type { Theme } from "./theme";

export type NavProps = {
  theme: Theme;
  signInUrl: string;
  currentUser: { name: string; appUrl: string } | null;
};

export function Nav({ theme, signInUrl, currentUser }: NavProps) {
  return (
    <nav
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        padding: "20px clamp(20px, 5vw, 40px)",
        display: "flex",
        alignItems: "center",
        gap: 16,
      }}
    >
      <a
        href="/"
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          fontWeight: 600,
          fontSize: 17,
          letterSpacing: -0.3,
          color: theme.fg,
          textDecoration: "none",
        }}
      >
        <LogoMark theme={theme} size={22} />
        Rarion
      </a>
      <div style={{ flex: 1 }} />
      {currentUser ? (
        <a
          href={currentUser.appUrl}
          style={{
            fontSize: 14,
            fontWeight: 500,
            color: theme.fg,
            textDecoration: "none",
          }}
        >
          Open Rarion
        </a>
      ) : (
        <a
          href={signInUrl}
          style={{
            fontSize: 14,
            color: theme.fg,
            textDecoration: "none",
          }}
        >
          Sign in
        </a>
      )}
    </nav>
  );
}
